import axios from "axios";

export function rejectHandoff(uuid) {
  return new Promise((resolve, reject) => {
    axios
      .post(
        `/consumer/admin/api/v1/item-replacement/handoff/${uuid}/reject`,
        {}
      )
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
